import * as SVG from './svg'
import * as PNG from './png'
import * as GIF from './gif'

export const IMAGES = {
  ...SVG,
  ...PNG,
  ...GIF
}
